module.exports = "pegasus/assets/blocks/social-1-tech.png";